/* eslint-disable prefer-destructuring */
import { isNil } from 'lodash';

const INNER_SPACING = 1.1;

const trendGranularity = (trendName, data) => {
    const trend = data?.trends?.[trendName];
    const trendData = trend?.data;
    if (!trendData?.length) return 1_000;
    const granularity = trend.granularity;
    const start = trendData[0].date;
    const last = trendData[trendData.length - 1].date;
    const end = last + granularity;
    return {
        granularity,
        start,
        last,
        end,
    };
};

const reducer = (max, curr) => {
    if (!max) return curr;
    if (!curr) return max;

    return {
        granularity: Math.max(max.granularity, curr.granularity),
        start: Math.min(max.start, curr.start),
        last: Math.max(max.last, curr.last),
        end: Math.max(max.end, curr.end),
    };
};

export const getTrendData = (def, data) => {
    return isNil(def?.dataIndex) ? data?.trends?.[def.key] : data?.[def.dataIndex]?.trends?.[def.key];
};

export const getTimes = (trendNames, data) => {
    return data ? trendNames.map((trendName) => trendGranularity(trendName, data)).reduce(reducer) : undefined;
};

export const getTimesOffset = (times, time, pointSize) => {
    if (!times) return 0;

    const timeSpan = time - times.start;
    const number = timeSpan / times.granularity;

    return number * (pointSize + INNER_SPACING);
};

const getNumPoints = (chartDef, data) => {
    if (!chartDef) return 0;

    const lengths = chartDef.chartTrends
        .filter((def) => !def.hidden)
        .map((def) => {
            const trendData = getTrendData(def, data);
            return trendData?.data?.length || 0;
        });

    return Math.max(1, ...lengths);
};

function getGranularity(chartDef, data) {
    const granularities = chartDef.chartTrends.map((def) => {
        const trendData = getTrendData(def, data);
        return trendData?.granularity || 0;
    });
    return Math.max(60000, ...granularities);
}

export const getPointWidth = (chartDef, data, chartWidth, timeRange) => {
    if (!data || !chartWidth || !chartDef) return 0;

    const granularity = getGranularity(chartDef, data);
    const numPoints = timeRange?.start ? (timeRange.end - timeRange.start) / granularity : getNumPoints(chartDef, data);

    return chartWidth / numPoints - INNER_SPACING || 0;
};

// Add gray for missing values
const addGray = (item) => {
    if (item.value?.count) return item;

    return {
        date: item.date,
        value: {
            gray: 100,
            green: 0,
            yellow: 0,
            orange: 0,
            red: 0,
        },
    };
};

export const convertStatusToStatusCounts = (metricName, data) => {
    const trendData = data?.trends[metricName] || [];
    const converted = trendData?.data?.map(addGray)?.map((slot) => {
        const worst = slot.value.worst || 'gray';
        return {
            ...slot,
            value: {
                count: 1,
                gray: 0,
                green: 0,
                yellow: 0,
                orange: 0,
                red: 0,
                worst,
                [worst]: 100,
            },
        };
    });

    return {
        trends: {
            [metricName]: {
                granularity: trendData?.granularity,
                data: converted,
            },
        },
    };
};
